/* eslint-disable */

/*
 * This is a generated file created by deere-ui-svg-to-react.
 *
 * Please do not modify this file directly as it will be regenerated at build time.
 */

"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

exports["default"] = _react2["default"].createClass({
    displayName: "cart",

    getDefaultProps: function getDefaultProps() {
        return {
            "st0": {
                "fillRule": "evenodd",
                "clipRule": "evenodd",
                "fill": "#666766"
            },
            "cart": {
                "backgroundImage": "none",
                "backgroundPosition": "0% 0%",
                "display": "inline",
                "fill": "#333"
            },
            "width": "24.9",
            "height": "24.8"
        };
    },

    render: function render() {
        return _react2["default"].createElement(
            "svg",
            { id: "Layer_1", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24.9 24.8", className: "cart", width: this.props.width, height: this.props.height, style: this.props.cart },
            _react2["default"].createElement("circle", { className: "st0", cx: "9.7", cy: "22.5", r: "2.3", style: this.props.st0 }),
            _react2["default"].createElement("circle", { className: "st0", cx: "19.7", cy: "22.5", r: "2.3", style: this.props.st0 }),
            _react2["default"].createElement("path", { className: "st0", d: "M22 19.3v-1.6H9l-.8-2.2h13.3l3.4-8.9-1.6-.5-3 7.8H7.6L4 4.6.3 3.8 0 5.4l2.7.6 5.2 13.3z", style: this.props.st0 })
        );
    }
});

/* eslint-enable */
module.exports = exports["default"];



// WEBPACK FOOTER //
// ./~/cap-it-ui.toggles/~/cap-it-ui.icons/lib/cart.js